import { ApolloError, gql } from '@apollo/client';

import { useApiGatewayQuery } from '~hooks';
import { Config, ConfiguratorQuery, ConfiguratorQueryVariables, Maybe } from '~types/appsync.types';

const GET_CONFIG = gql`
  query Configurator($context: RequestContext!) {
    getConfig(context: $context) {
      configKeys {
        id
        value
      }
    }
  }
`;

export const useConfig = (): [Maybe<Config> | undefined, boolean, ApolloError | undefined] => {
  const { loading, error, data } = useApiGatewayQuery<
    ConfiguratorQuery,
    ConfiguratorQueryVariables
  >(GET_CONFIG);

  return [data?.getConfig, loading, error];
};
